import { UseCase } from "../../base";
import { LocationsRepository } from "../../repositories";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { Dawa } from "../../domain/models";

@Injectable({providedIn: 'root'})
export class GetDawaAutoCompleteLocationsUsecase implements UseCase<string, Dawa[]> {
  constructor(private locationRepository: LocationsRepository) {
  }

  execute(address: string): Observable<Dawa[]> {
    return this.locationRepository.getDawaAutoCompleteLocations(address);
  }
}
